import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';

const model = {
  state: {
    initData: {},
  },
  reducers: {
    setState(state: any, partialState: any) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { marketingLogistics }, getState }: { dispatch: any; getState: any }) => ({
    // 新建物流补贴
    async postCreateSubsidies(params: any, callback: Function) {
      const data = await fetch('/saasmerchant/web/fslogistics/subsidies/subsidiesCreate', {
        type: 'POST',
        useJson: true,
        params: filterNull(params),
      });
      if (data) {
        callback();
      }
    },
    // 修改/删除物流补贴
    async postUpdateSubsidies(params: any, callback: Function) {
      const data = await fetch('/saasmerchant/web/fslogistics/subsidies/subsidiesUpdate', {
        type: 'POST',
        useJson: true,
        params: filterNull(params),
      });
      if (data) {
        callback();
      }
    },
    // 物流补贴更新状态
    async getUpdateSubsidiesStatus(params: any, callback: Function) {
      const data = await fetch('/saasmerchant/web/fslogistics/subsidies/subsidiesUpdateStatus', {
        params: filterNull(params),
      });
      if (data) {
        callback();
      }
    },
    // 查询物流补贴详情
    async getSubsidiesDetail(subsidiesId: number) {
      const data = await fetch('/saasmerchant/web/fslogistics/subsidies/subsidiesDetail', {
        params: { subsidiesId },
      });
      if (data) {
        marketingLogistics.setState({ initData: data });
      }
    },
    clearInitData() {
      marketingLogistics.setState({ initData: {} });
    },
  }),
};

export default model;
